import React from 'react';
import Appearance from 'styles/Appearance.js';
import { BorderBeam } from 'views/MagicUI.js';

const AskRequiem = ({ onClick, style }) => {
    return (
        <div 
        className={`text-button`}
        onClick={onClick}
        style={{
            alignItems: 'center',
            backgroundColor: Appearance.colors.divider(),
            borderRadius: 8,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            height: 45,
            minWidth: 0,
            padding: '6px 12px 6px 12px',
            position: 'relative',
            whiteSpace: 'normal',
            width: '100%',
            ...style
        }}>
            <span style={{
                color: Appearance.colors.text(),
                display: 'block',
                fontSize: 12,
                fontFamily: 'Zen Dots',
                fontWeight: 800,
                maxWidth: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }}>{'Ask Requiem'.toUpperCase()}</span>
            <BorderBeam
            colorFrom={Appearance.colors.yellow}
            colorTo={Appearance.colors.red}
            duration={8}
            useSize={true}
            style={{
                border: `2px solid ${Appearance.colors.softBorder()}`,
                borderRadius: 8 
            }} />
        </div>
    )
}

export default AskRequiem;